
  module.exports =
  {

    abortiveVisits:
    {

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#visits', 'AbortiveVisit', 'abortiveVisits')

      }

    },

    record:
    {

      _init: function ()
      {
  
        $('#modal-company_id').not('.js-ignore').change(function ()
        {
  
          var company_id = $(this).val()
  
          var development = $('#modal-development_id')
  
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }
  
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown')
          }
  
        }
        ).addClass('js-ignore').trigger('change')

      }

    }

  }